/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Resources_Faq_Macros_QInputs */

const en_gc_resources_faq_macros_q = /** @type {(inputs: Gc_Resources_Faq_Macros_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Will my VBA macros run?`)
};

const zh_gc_resources_faq_macros_q = /** @type {(inputs: Gc_Resources_Faq_Macros_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VBA 宏可以运行吗？`)
};

/**
* | output |
* | --- |
* | "Will my VBA macros run?" |
*
* @param {Gc_Resources_Faq_Macros_QInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_resources_faq_macros_q = /** @type {((inputs?: Gc_Resources_Faq_Macros_QInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Resources_Faq_Macros_QInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_resources_faq_macros_q(inputs)
	return zh_gc_resources_faq_macros_q(inputs)
});
export { gc_resources_faq_macros_q as "gc.resources.faq.macros.q" }